import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export interface CustomerCenter {
  guid: string;
  itemId: number;
  name: string;
  code: string;
  creationDate: Date;
  modifyDate?: Date;
  modifyUser?: string;
  pkId: number;
  damageReportEmailAddress: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerCenterService extends ApiService {
  private customerCenters$?: Observable<CustomerCenter[]>;
  constructor(public http: HttpClient) {
    super(http);
  }

  baseUri = 'socrates/authz/api/references/customercenters';

  public getAll(): Observable<CustomerCenter[]> {
    return this.http.get<CustomerCenter[]>(this.endpoint(this.baseUri)).pipe(shareReplay());
  }

  public getAllWithSelectedProperties(): Observable<CustomerCenter[]> {
    const selectOption = '$select=guid,damageReportEmailAddress';
    const uri = `${this.baseUri}?${selectOption}`;
    if (!this.customerCenters$) {
      this.customerCenters$ = this.http.get<CustomerCenter[]>(this.endpoint(uri)).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }

    return this.customerCenters$;
  }
}
